import React from "react";
import { useMutation } from "@tanstack/react-query";
import { createData } from "../../../utility/adminApi";

export default function KYCForm({
  formData,
  setFormData,
  setModal,
  handleBack,
}) {
  const handleFileChange = (e, name) => {
    const file = e.target.files[0];
    if (!file) return;

    setFormData((prev) => ({
      ...prev,
      [name]: file,
    }));
  };

  const submitLoan = useMutation({
    mutationFn: (loanForm) => createData("loans/store", loanForm),
    onSuccess: () => {
      console.log("Success");
    },
  });

  const handleSubmit = (e) => {
    e.preventDefault(); // prevent page reload
    console.log("Submitted data:", formData);
    // sessionStorage.setItem("form", JSON.stringify(formData));
    const data = new FormData();

    for (const key in formData) {
      data.append(key, formData[key]);
    }
    setModal(true);
    submitLoan.mutate(data);
  };

  return (
    <form onSubmit={handleSubmit} className="max-w-ful mx-auto p-6 bg-white  ">
      <div className="mb-8 ">
        <div className=" flex flex-col md:grid md:grid-cols-2 gap-8">
          <div className="mb-4">
            <h2 className="block text-sm font-medium text-gray-700">
              {" "}
              Valid government-issued ID
            </h2>
            <select
              name="goverment_idcard"
              className="w-full p-2 border rounded mb-2"
              defaultValue=""
            >
              <option value="" disabled>
                Select a document type
              </option>

              <option value=" National Identity Card (NIN slip or e-ID card)">
                {" "}
                National Identity Card (NIN slip or e-ID card)
              </option>
              <option value="Voter’s Card (PVC)">Voter’s Card (PVC)</option>
              <option value="International Passport">
                International Passport
              </option>

              <option value="National Identity Number Slip (with QR code)">
                National Identity Number Slip (with QR code)
              </option>
            </select>

            <div className="flex items-center gap-2">
              <input
                type="file"
                accept="image/*"
                onChange={(e) => handleFileChange(e, "government_idcard")}
                className="w-full border p-2"
              />
            </div>
          </div>

          <div className="mb-4">
            <h2 className="block text-sm font-medium text-gray-700">
              {" "}
              Proof of address
            </h2>
            <select
              name="goverment_idcard"
              className="w-full p-2 border rounded mb-2"
              defaultValue=""
            >
              <option value="" disabled>
                Select a document type
              </option>
              <option value="Utility Bill">
                Utility Bill (not older than 3 months)
              </option>
              <option value="Bank Statement">
                Bank Statement (with address visible)
              </option>
              <option value="Tenancy or Lease Agreement">
                Tenancy or Lease Agreement
              </option>
              <option value="Official Government-Issued Document">
                Official Government-Issued Document
              </option>
              <option value="Letter of Residence">
                Letter of Residence from a Traditional Ruler or Local Government
              </option>
              <option value="Tax or Utility Receipts">
                Tax or Utility Receipts Issued by LIRS/FIRS or LGAs
              </option>
            </select>

            <div className="flex items-center gap-2">
              <input
                type="file"
                accept="image/*"
                onChange={(e) => handleFileChange(e, "proof_of_address")}
                className="w-full border p-2 rounded"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-col md:grid md:grid-cols-2 md:grid-rows-2 gap-8">
        <div className="flex flex-col  gap-2">
          <h3 className="block text-sm font-medium text-gray-700">
            Business registration certificate (If applicable)
          </h3>
          <input
            type="file"
            accept="image/*"
            onChange={(e) => handleFileChange(e, "business_certificate")}
            className="w-full border p-2 rounded"
          />
        </div>
        <div className="flex flex-col  gap-2">
          <h3 className="block text-sm font-medium text-gray-700">
            Business operating license (If required for the industry)
          </h3>
          <input
            type="file"
            accept="image/*"
            onChange={(e) => handleFileChange(e, "operating_lincense")}
            className="w-full border p-2 rounded"
          />
        </div>
        <div className="flex flex-col  gap-2">
          <h3 className="block text-sm font-medium text-gray-700">
            Recent passport photograph
          </h3>
          <input
            type="file"
            accept="image/*"
            onChange={(e) => handleFileChange(e, "photograph")}
            className="w-full border p-2 rounded"
          />
        </div>
        <div className="flex flex-col  gap-2">
          <h3 className="block text-sm font-medium text-gray-700">
            Selfie for facial verification{" "}
          </h3>
          <input
            type="file"
            accept="image/*"
            onChange={(e) => handleFileChange(e, "facial_verification")}
            className="w-full border p-2 rounded"
          />
        </div>
      </div>

      <div className="mt-10">
        <h2 className="text-xl font-semibold mb-4">
          Business establishment images
        </h2>
        <div className="flex flex-col md:grid md:grid-cols-2 md:grid-rows-2 gap-8">
          <div className="flex flex-col ">
            <h3 className="block text-sm font-medium text-gray-700 mb-2">
              Exterior view
            </h3>
            <input
              type="file"
              accept="image/*"
              onChange={(e) => handleFileChange(e, "exterior_view")}
              className="w-full border p-2 rounded"
            />
            <h4 className="text-xs text-green-500">
              Ensure the business signage and location are properly visible
            </h4>
          </div>
          <div className="flex flex-col ">
            <h3 className="block text-sm font-medium text-gray-700 mb-2">
              Interior view
            </h3>
            <input
              type="file"
              accept="image/*"
              onChange={(e) => handleFileChange(e, "interior_view")}
              className="w-full border p-2 rounded"
            />
            <h4 className="text-xs text-green-500">
              Ensure the workspace, equipment & business operations are properly
              visible{" "}
            </h4>
          </div>
          <div className="flex flex-col ">
            <h3 className="block text-sm font-medium text-gray-700 mb-2">
              01POS terminal setup
            </h3>
            <input
              type="file"
              accept="image/*"
              onChange={(e) => handleFileChange(e, "terminal_setup")}
              className="w-full border p-2 rounded"
            />
            {/* <h4 className="text-xs text-green-500">
              Attach a photo if applicable{" "}
            </h4> */}
          </div>
          <div className="flex flex-col ">
            <h3 className="block text-sm font-medium text-gray-700 mb-2">
              Staff or customers in action
            </h3>
            <input
              type="file"
              accept="image/*"
              onChange={(e) => handleFileChange(e, "action_view")}
              className="w-full border p-2 rounded"
            />
            {/* <h4 className="text-xs text-green-500">
              Optional but helpful for credibility
            </h4> */}
          </div>
        </div>
      </div>
      <div className="flex justify-center mt-6">
        <button
          type="button"
          onClick={handleBack}
          className="px-6 py-2 bg-gray-300 rounded"
        >
          Back
        </button>{" "}
        <button
          type="submit"
          className="ml-auto px-6 py-2 bg-blue-600 text-white rounded"
        >
          Submit
        </button>
      </div>
    </form>
  );
}
